module.exports = window['vue'];